egtoPassword.$inject = [];

export function egtoPassword() {
    var directive = {
        require: 'ngModel',
        link: link,
        restrict: 'A'
    };
    return directive;

    function link(scope, element, attrs, ngModel) {
        ngModel.$validators.passwordLength = validatePasswordLength;
        ngModel.$validators.passwordNumbers = validatePasswordNumbers;
        ngModel.$validators.passwordUppercase = validatePasswordUppercase;
        ngModel.$validators.passwordLowercase = validatePasswordLowercase;
        ngModel.$validators.validateContainsIllChars = validateContainsIllChars;

        function validatePasswordLength(modelValue, viewValue) {
            return /.{8,}/.test(viewValue || '');
        }

        function validatePasswordNumbers(modelValue, viewValue) {
            return /[0-9]/g.test(viewValue || '');
        }

        function validatePasswordUppercase(modelValue, viewValue) {
            return /[A-Z]/g.test(viewValue || '');
        }

        function validatePasswordLowercase(modelValue, viewValue) {
            return /[a-z]/g.test(viewValue || '');
        }

        function validateContainsIllChars(modelValue, viewValue) {
            return /^[\x21-\x7F]*$/g.test(viewValue || '');
        }
    }
}

